import Forms from "../../../../app/Components/Forms/Forms";
import App from "../../../../app/App";
import Hotmenu from "../../../../app/Components/Hotmenu/Hotmenu";
import DragAndDrop from "../../../../app/Components/DragAndDrop/DragAndDrop";

const FundFiller = {

    decimals: {},

    tatrabanka_nav_decimals: 6,

    init() {

        this.el = $('[component="FundFiller"], [component="DssSavers"]');

        if (!this.el.length) {
            return;
        }

        this.form = this.el.find("form");
        this.button = {
            ajax: this.el.find('[element="ajax"]')
        }
        this.hotlinks = this.el.find('[component="hotMenu"]');
        this.inputs = this.form.find('input[name]');//'input[name="nav"], input[name="ahdj"]'
        this.mouseIndicator = this.el.find(".mouse-indicator");
        this.submitButton = $('.formSubmit');
        this.numberOfCompanies = parseInt($('[funds]').attr("funds"));

        this.start();
        this.bind();
    },

    start() {
        FundFiller.setDecimalsByProject();

        Forms.init(this.form);
        //Forms.focusFirstInput(this.currentFormByDate());
        //Forms.focusFirstInput(this.form);
        Hotmenu.init();
        DragAndDrop.init();

        Forms.setFormSubmitButton(this.submitButton);
        Forms.setButtonPulseAfterEdit();
        Forms.setInputNotices(true);
    },

    bind() {
        this.submitButton.on("click", function () {
            $(FundFiller.form).trigger("submit");
        });

        this.form.submit((event) => {
            const send = {
                data: this.prepareFormData(),
                ...$('[data-week]').data()
            }

            Forms.setSendData(send);
        });

        this.form.on("mouseenter", function () {
            if ($(FundFiller.form).children('section').outerWidth() > $(FundFiller.form).width()) {
                $(FundFiller.mouseIndicator).css("opacity", 1);
            }
        });

        if (this.el.is('[component="FundFiller"]') || this.numberOfCompanies >= 1) {
            $(FundFiller.form).on('mousewheel wheel', function (event) {

                if ($(event.target).is(".leftLabels") || $(event.target).parents(".leftLabels").length || $(event.target).parents(".asHeader .date").length) {
                    return;
                }

                event.preventDefault();

                let scrollLeft = $(this).scrollLeft();
                //let end = $(this).children('section').outerWidth() - $(this).width();

                $(this).scrollLeft(scrollLeft + (event.originalEvent.deltaY * 2));

                if (!FundFiller.mouseIndicator.is(".done")) {
                    setTimeout(() => {
                        FundFiller.mouseIndicator.addClass("done");
                    }, 1500);
                }
            });

            $(FundFiller.form).on('scroll', function (event) {
                let scrollLeft = $(this).scrollLeft();
                let end = $(this).children('section').outerWidth() - $(this).width();

                // if (scrollLeft >= end) {
                //     FundFiller.mouseIndicator.css("opacity", 0);
                // } else {
                //     FundFiller.mouseIndicator.css("opacity", 1);
                // }

                if (scrollLeft !== 0 && scrollLeft !== end) {
                    $(this).addClass("scrolled");
                } else {
                    $(this).removeClass("scrolled");
                }

                if (scrollLeft === end) {
                    $(this).addClass("end");
                } else {
                    $(this).removeClass("end");
                }
            });
        }

        this.el.find('.date').on("click", (event) => {

            if ($(event.currentTarget).parent("section").is(".asHeader")) {
                return;
            }

            Forms.focusFirstInput($(event.currentTarget).parent("section"), 0);
        });

        window.addEventListener('beforeunload', function (e) {

            // Check if any of the input fields are filled
            if (!Forms.saved) {

                // Cancel the event and show alert that
                // the unsaved changes would be lost
                e.preventDefault();
                e.returnValue = '';
            }
        });

        // this.inputs.on("paste", function (e) {
        //
        //     let clipBoardValues = FundFiller.getClipboardContent(e);
        //
        //     //console.log(clipBoardValues);
        //     if (clipBoardValues.length >= 5 && clipBoardValues.length <= 6) {
        //         e.preventDefault();
        //
        //         let input = $(this).attr("name");
        //         let fund = $(this).parents('[component="FundBox"]').data("fund");
        //         let days = $('[component="DayBox"][date]');
        //
        //         let sameInputsDays = days.find('[data-fund="' + fund + '"] [name="' + input + '"]');
        //
        //         clipBoardValues.forEach((value, index) => {
        //             if (value) {
        //
        //                 if ($(sameInputsDays[index]).length) {
        //
        //                     let parsedValue = FundFiller.parseValue(
        //                         $(sameInputsDays[index]),
        //                         value
        //                     );
        //
        //                     $(sameInputsDays[index]).val(parsedValue).trigger("change");
        //                 }
        //             }
        //         });
        //     }
        //
        //     if (clipBoardValues.length >= 8) {
        //         e.preventDefault();
        //
        //         let fund = $(this).parents('[component="FundBox"]').data("fund");
        //         let days = $('[component="DayBox"][date]');
        //
        //         let sameInputsDays = days.find('[data-fund="' + fund + '"] [name]');
        //
        //         clipBoardValues.forEach((value, index) => {
        //             if (value) {
        //
        //                 if ($(sameInputsDays[index]).length) {
        //
        //                     let parsedValue = FundFiller.parseValue(
        //                         $(sameInputsDays[index]),
        //                         value
        //                     );
        //
        //                     $(sameInputsDays[index]).val(parsedValue).trigger("change");
        //                 }
        //             }
        //         });
        //     }
        // });

        this.inputs.change((element) => {
            let input = $(element.currentTarget);
            let value = input.val();

            let parsedValue = FundFiller.parseValue(input, value);

            input.val(parsedValue);
        });

        this.inputs.on("focusin focusout", function (event) {
            let dss = $(this).parents().closest('[component="FundBox"]').data("dss");

            if (event.type === "focusout") {
                $('[element="dssList"] button').removeClass("active");
                return;
            }

            if ($('[element="dssList"]').length) {
                $('[element="dssList"] button').removeClass("active");

                $('[element="dssList"] button[data-dss="' + dss + '"]').addClass("active");
            }
        });

        this.inputs.on("focus", (evt) => {
            $(evt.currentTarget).select();
        });

        this.inputs.on("keypress", function (event) {
            return event.charCode === 0 || event.charCode === 44 || /\d/.test(String.fromCharCode(event.charCode));
        });

        $('[element="dssList"] button').on("click", function (element) {
            let firstBox = FundFiller.el.find('[component="FundBox"][data-dss="' + $(this).data("dss") + '"]')[0];

            $(firstBox).find('[component="Input"] input')[0].focus();
        });
    },

    prepareFormData() {

        const formData = {};

        this.form.children('[date]').each((index, item) => {

            let date = $(item).attr("date");

            formData[date] = {};

            $(item).find('[component="FundBox"]').each((i, fund) => {
                let fundID = $(fund).data().fund;
                const fundData = Forms.inputData(fund);

                formData[date][fundID] = {...fundData};
            });
        });

        return formData;
    },

    // currentFormByDate() {
    //     return FundFiller.el.find('[component="DayBox"][date="' + (App.currentDate.toISOString().slice(0, 10)) + '"]');
    // },

    parseValue(input, value) {
        let numberOfCommas = value.split(",").length - 1;
        let numberOfDots = value.split(".").length - 1;
        let decimalsParam = FundFiller.decimals[input.attr("name")];

        if (typeof INPUT_SETTINGS !== 'undefined' && !decimalsParam) {
            if (INPUT_SETTINGS[input.attr("name")].decimals) {
                decimalsParam = INPUT_SETTINGS[input.attr("name")].decimals;
            }
        }

        if (App.project === "adds" && input.is('[name="nav"]')) {
            if (input.parents('section[component="FundBox"]').data("dss") === 1) {
                decimalsParam = FundFiller.tatrabanka_nav_decimals;
            }
        }

        value = value.replaceAll(/\s/g, "");
        value = value.replaceAll(/€/g, "");

        if (numberOfCommas === 1 && numberOfDots === 0) {
            value = value.replaceAll(/,/g, ".");
        }

        if (value) {
            value = parseFloat(value).toLocaleString("sk-SK", {minimumFractionDigits: decimalsParam});
        }

        return value;
    },

    // getClipboardContent(e) {
    //     let clp = (e.originalEvent || e).clipboardData;
    //     let text = null;
    //
    //     if (clp === undefined || clp === null) {
    //         text = window.clipboardData.getData("text") || "";
    //     } else {
    //         text = clp.getData('text/plain') || "";
    //     }
    //
    //     text = text.split(/[\t\r\n]+/);
    //
    //     return text;//text.split("\r\n");
    // },

    setDecimalsByProject() {
        let nav;

        if (App.project === "adss") {
            nav = 3;
        } else {
            nav = 3;
        }

        FundFiller.decimals = {
            nav: nav,
            ahdj: 6,
        };
    }
}
export default FundFiller;